<script>
    export let title = "";
    export let text = "";
    export let classes = "";
    export let h2Classes = "text-dark font-weight-bolder"; // Default classes for h2
    export let textClasses = ""; // Additional classes for the text
</script>

<div class="text-block {classes}">
    <h2 class="mb-2 {h2Classes}">{title}</h2>
    <p class="{textClasses}" style="line-height: 1.5em;">{@html text}</p>
</div>
